import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerImageGraphic } from "@visactor/vrender-core/register/graphic";

import { imageModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindImageCanvasPickerContribution } from "../picker/contributions/canvas-picker/image-module";

import { bindImageMathPickerContribution } from "../picker/contributions/math-picker/image-module";

function _registerImage() {
    if (_registerImage.__loaded) return;
    _registerImage.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerImageGraphic(), imageModule({
        bind: legacyContext.bind
    }), browser ? bindImageCanvasPickerContribution(legacyContext) : bindImageMathPickerContribution(legacyContext);
}

_registerImage.__loaded = !1;

export const registerImage = _registerImage;
//# sourceMappingURL=register-image.js.map